export const gpmImg3 = require('./gpm-img3.png?webp');
export const monitor = require('./monitor.png?webp');
export const architecture = require('./architecture.png?webp');
export const lines = require('./lines.png?webp');
export const mobileLines = require('./mobileLines.png?webp');
export const arc = require('./arc.png?webp');
export const cad = require('./cad.png?webp');
export const layer = require('./layer.png?webp');
export const open = require('./open.png?webp');
export const google = require('./google.png?webp');
export const qgis = require('./qgis.png?webp');
export const post = require('./post.png?webp');
export const construction = require('./construction.png?webp');
export const foresty = require('./foresty.png?webp');
export const fulfillment = require('./fulfillment.png?webp');
export const mining = require('./mining.png?webp');
export const osp = require('./osp.png?webp');
export const power = require('./power.png?webp');
export const ospGlobe = require('./ospGlobe.png?webp');
export const constructionGlobe = require('./constructionGlobe.png?webp');
export const miningGlobe = require('./miningGlobe.png?webp');
export const forestryGlobe = require('./forestryGlobe.png?webp');
export const fulfilmentGlobe = require('./fulfilmentGlobe.png?webp');
export const powerGlobe = require('./powerGlobe.png?webp');
export const arcGISMob = require('./arcGISMob.png?webp');
export const autoCadMob = require('./autoCadMob.png?webp');
export const googleMob = require('./googleMob.png?webp');
export const oPenLayerMob = require('./oPenLayerMob.png?webp');
export const openstreetmapMob = require('./openstreetmapMob.png?webp');
export const qGISMob = require('./qGISMob.png?webp');
export const postGISMob = require('./postGISMob.png?webp');
